export interface LevelFormState {
    name: string | null;
    isActive: boolean;
}
